"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const fetchy_1 = __importDefault(require("@devicious/fetchy"));
var Research;
(function (Research) {
    const $searchBar = document.querySelector('.search-bar');
    if ($searchBar) {
        const $input = $searchBar.querySelector('.input-container input');
        const $resultTitle = $searchBar.querySelector('.title');
        const $resultList = $searchBar.querySelector('.tool-list');
        const $spinner = $searchBar.querySelector('.spinner');
        const $noResults = $searchBar.querySelector('.no-results');
        let t;
        function bolder(input) {
            const $items = $searchBar.querySelectorAll('.tool-list .resulted-tool');
            $items.forEach($item => {
                const $texts = $item.querySelectorAll('span .field__item p');
                $texts.forEach($text => {
                    let regex = new RegExp(input, 'gi');
                    $text.innerHTML = $text.innerHTML.replace(regex, '<b>' + input + '</b>');
                });
            });
        }
        function spinnerOn() {
            $spinner.style.display = "block";
        }
        function spinnerOff() {
            $spinner.style.display = "none";
        }
        function clearInput() {
            const $clear = $searchBar.querySelector('.input-container .icn-x');
            $clear.classList.add('is-visible');
            $clear.addEventListener('click', () => {
                $input.value = '';
                $resultList.innerHTML = '';
                $resultTitle.classList.remove('has-results');
                $noResults.classList.remove('is-visible');
                $clear.classList.remove('is-visible');
            });
        }
        $input.addEventListener(('keyup'), () => {
            const $countrySelect = document.querySelector('#footer .body .content-wrapper .country-switcher label select');
            const $country = $countrySelect.querySelector('option:checked');
            localStorage.setItem('countryName', $country.innerHTML);
            const $currentLangOption = document.querySelector('#footer .body .content-wrapper .country-switcher label select option[selected]');
            let lang = $currentLangOption.getAttribute('value');
            t && clearTimeout(t);
            t = setTimeout(() => {
                let text = $input.value;
                $resultList.innerHTML = '';
                $resultTitle.classList.remove('has-results');
                $noResults.classList.remove('is-visible');
                if ($input.value) {
                    let countryName = localStorage.countryName;
                    const searchResult = new fetchy_1.default("/" + lang + "/api/v1/tools?field_keyword=" + text + "&lang=" + lang);
                    spinnerOn();
                    clearInput();
                    searchResult
                        .then((results) => {
                        if (countryName != 'All') {
                            if (results.length) {
                                results.forEach((result, index) => {
                                    if (!result.item.includes("hreflang=\"en\">" + countryName + "</a>\n\n<!--") && result.item.includes("field--taxonomy-term--field-country-tool.html.twig")) {
                                        delete results[index];
                                        results.length = results.length - 1;
                                    }
                                });
                            }
                        }
                        if (results.length) {
                            $resultTitle.classList.add('has-results');
                            $resultList.innerHTML = results.map(result => result.item).join('');
                            bolder($input.value);
                        }
                        else {
                            $noResults.classList.add('is-visible');
                        }
                    })
                        .finally(() => {
                        spinnerOff();
                    })
                        .catch((error) => {
                        spinnerOff();
                        console.log(error);
                    });
                }
            }, 250);
        });
    }
})(Research || (Research = {}));
